module.exports = __webpack_public_path__ + "static/media/300x600.e8e4c286.png";